import { useSelector } from 'react-redux';

const Clickable = ({
  children,
  onClick = () => null,
  marg,
  zIndex,
  pos,
  goThrough,
  disabled,
  ogOpacity,
  wid,
  ht,
  action,
  style,
  className = ''
}) => {
  const loadingButton = useSelector((state) => state?.appState?.loadingButton),
    isLoading = action && action === loadingButton;

  function handleClick(e) {
    if (disabled) return;
    onClick(e);

    if (!goThrough) return;
    if (!e) e = window.event;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
  }

  const isDisabled = disabled || isLoading;

  // Build Tailwind classes
  const baseClasses = 'cursor-pointer';
  const disabledClasses = isDisabled && !ogOpacity ? 'opacity-60' : '';
  const activeClasses = !isDisabled ? 'active:opacity-60' : '';

  const combinedClassName = [
    baseClasses,
    activeClasses,
    disabledClasses,
    className
  ]
    .filter(Boolean)
    .join(' ');

  // Build inline styles for dynamic values
  const combinedStyle = {
    margin: marg || '0',
    ...(zIndex && { zIndex }),
    ...(pos && { position: pos }),
    ...(ht && { height: ht }),
    ...(wid && { width: wid }),
    ...style
  };

  return (
    <div
      onClick={handleClick}
      className={combinedClassName}
      style={combinedStyle}
    >
      {children}
    </div>
  );
};

export default Clickable;
